export enum TeVariableTypeEnum {

   simple,
   object,
   system,
   json,
}